import React from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Email,
  Phone,
  LocationOn,
  AccessTime,
  LinkedIn,
} from "@mui/icons-material";
import ScrollToTop from "./ScrollToTop";
import SEO from "../components/Layout/SEO";

import ContactForm from "../components/Contact/ContactForm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ContactPage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <>
      <SEO
        title="Contact Us"
        description="Get in touch with ProtoDiag Solutions. Contact our team in Noida, India for enterprise telecom solutions, product inquiries, and technical support. Email: info@protodiag.com | Phone: +91-9899817807"
        keywords="contact ProtoDiag, ProtoDiag Solutions contact, telecom solutions contact, Noida telecom company, enterprise communication support"
        url="https://protodiag-solutions.vercel.app/contact"
      />
      <ScrollToTop />

      {/* Hero Section */}
      <Box
        id="contact-section"
        sx={{
          py: 10,
          backgroundColor: "primary.main",
          color: "white",
        }}
      >
        <Container>
          <Typography
            variant="h2"
            component="h1"
            fontWeight="bold"
            gutterBottom
          >
            Contact Us
          </Typography>
          <Typography variant="h5" sx={{ maxWidth: 700 }}>
            Have questions or interested in our solutions? We'd love to hear
            from you.
          </Typography>
        </Container>
      </Box>

      {/* Contact Information and Form */}
      <Box sx={{ py: 8 }}>
        <Container>
          <Grid container spacing={4}>
            {/* Contact Form */}
            <Grid item xs={12} md={8}>
              <ContactForm />
            </Grid>

            {/* Contact Information */}
            <Grid item xs={12} md={4}>
              <Paper elevation={3} sx={{ p: 4, height: "100%" }}>
                <Typography
                  variant="h5"
                  component="h3"
                  gutterBottom
                  fontWeight="bold"
                >
                  Get in Touch
                </Typography>

                <List sx={{ pt: 2 }}>
                  <ListItem disableGutters>
                    <ListItemIcon>
                      <Email color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Email"
                      secondary="info@protodiag.com"
                      primaryTypographyProps={{ fontWeight: "medium" }}
                    />
                  </ListItem>

                  <ListItem disableGutters>
                    <ListItemIcon>
                      <Phone color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Phone"
                      secondary="+91-9899817807 / +91-9910274500"
                      primaryTypographyProps={{ fontWeight: "medium" }}
                    />
                  </ListItem>

                  <ListItem disableGutters>
                    <ListItemIcon>
                      <LocationOn color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Address"
                      secondary="1st floor, A-5, Grovy Optiva, Block A, Sector 68, Noida, Basi Bahuddin Nagar, Uttar Pradesh 201316"
                      primaryTypographyProps={{ fontWeight: "medium" }}
                    />
                  </ListItem>

                  <ListItem disableGutters>
                    <ListItemIcon>
                      <AccessTime color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Business Hours"
                      secondary="Mon - Fri: 9:00 AM - 6:00 PM IST"
                      primaryTypographyProps={{ fontWeight: "medium" }}
                    />
                  </ListItem>
                </List>

                {/* Social Media Links */}
                <Box sx={{ mt: 4 }}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    fontWeight="medium"
                  >
                    Follow Us
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                    <LinkedIn
                      color="primary"
                      fontSize="large"
                      sx={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open(
                          "https://linkedin.com/company/protodiag",
                          "_blank",
                        )
                      }
                    />
                    {/* <Twitter
                      color="primary"
                      fontSize="large"
                      sx={{ cursor: "pointer" }}
                      onClick={() =>
                        window.open("https://twitter.com/protodiag", "_blank")
                      }
                    /> */}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Map Section */}
      <Box sx={{ py: 4, backgroundColor: "#f7f9fc" }}>
        <Container>
          <Typography
            variant="h5"
            component="h3"
            align="center"
            gutterBottom
            fontWeight="bold"
          >
            Our Location
          </Typography>
          <Box sx={{ height: 400, width: "100%", mt: 4 }}>
            <iframe
              title="Google Map - ProtoDiag Location"
              src="https://www.google.com/maps?q=8th+floor,+A-5,+Grovy+Optiva,+Block+A,+Sector+68,+Noida,+Basi+Bahuddin+Nagar,+Uttar+Pradesh+201316&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default ContactPage;
